import { useParams, useNavigate } from "react-router-dom";
import { Layout } from "../../components/Layout";
import ReactMarkdown from "react-markdown";
import { POLICY_DOCUMENTS } from "../../../../constants/policy-documents";
import { UNDERLINE_CLASS } from "../../utils";
import { useEffect } from "react";

function PolicyDocument({ document }: { document: string }) {
  return (
    <Layout headerStyle="sm">
      <div className=" text-left px-7 m-auto max-w-3xl ">
        <ReactMarkdown
          components={{
            h1: (props) => <h1 className=" my-2 mt-4 ">{props.children}</h1>,
            h2: (props) => <h2 className=" mt-4 ">{props.children}</h2>,
            p: (props) => <p className=" my-2 ">{props.children}</p>,
            ul: (props) => (
              <ul className=" list-disc mx-4 my-2 ">{props.children}</ul>
            ),
            a: (props) => (
              <a href={props.href} className={UNDERLINE_CLASS}>
                {props.children}
              </a>
            ),
          }}
        >
          {document}
        </ReactMarkdown>
      </div>
    </Layout>
  );
}

export default function PolicyPage() {
  const { slug } = useParams<{ slug: string }>();
  const navigate = useNavigate();

  const documentData = POLICY_DOCUMENTS.find(
    (doc) => doc.slug === slug
  );

  useEffect(() => {
    // If document not found, redirect to 404
    if (!documentData) {
      navigate("/404", { replace: true });
    }
  }, [documentData, navigate]);

  if (!documentData) {
    return null;
  }

  return <PolicyDocument document={documentData.content} />;
}
